import React from "react"
import { Button } from "react-bootstrap"
import PageLayout from "../components/PageLayout"
import Footer from "../components/Footer"

import "bootstrap/dist/css/bootstrap.min.css"

import {
  content,
} from './index.module.css'

const IndexPage = ({ data }) => {
  return (
    <PageLayout>
      <div className={content}>
        <main>
          <div className="pricing-header p-3 pb-md-4 mx-auto text-center">
            <h1 className="display-4 fw-normal">Assessment Report Archive</h1>
            <p className="fs-5 text-muted">

            </p>
          </div>

          <div className="mb-4 text-center">
            <span className="h3">Version 2.0 Assessment Archive</span>
          </div>

          <div className="row row-cols-1 row-cols-md-3 mb-4 text-center">
            <div className="col mx-auto">
              <div className="card mb-4 rounded-3 shadow-sm" style={{width: "100%"}}>
                <div className="card-header py-3 bg-primary text-white">
                  <h4 className="my-0 fw-normal">Reports for 2024-2025</h4>
                </div>
                <div className="card-body">
                  <p>
                  All submitted program and general education learning outcomes assessment reports for the academic year
                  </p>
                    <Button
                      href="v2/2024-2025"
                      variant="primary"
                      className="w-100"
                      size="lg"
                      >
                      View
                    </Button>
                </div>
              </div>
            </div>  
          </div>

          <div className="mb-4 text-center">
            <span className="h3">Version 1.0 Assessment Archive</span>
          </div>

          <div className="row row-cols-1 row-cols-md-3 mb-4 text-center">

          <div className="col">
              <div className="card mb-4 rounded-3 shadow-sm" style={{width: "100%"}}>
                <div className="card-header py-3">
                  <h4 className="my-0 fw-normal">Reports for 2022-2023</h4>
                </div>
                <div className="card-body">
                  <p>
                  All submitted program and general education learning outcomes assessment reports for the academic year
                  </p>
                    <Button
                      href="v1/2022-2023"
                      variant="outline-primary"
                      className="w-100"
                      size="lg"
                      >
                      View
                    </Button>
                </div>
              </div>
            </div>


            <div className="col">
              <div className="card mb-4 rounded-3 shadow-sm" style={{width: "100%"}}>
                <div className="card-header py-3">
                  <h4 className="my-0 fw-normal">Reports for 2021-2022</h4>
                </div>
                <div className="card-body">
                  <p>
                  All submitted program and general education learning outcomes assessment reports for the academic year
                  </p>
                    <Button
                      href="v1/2021-2022"
                      variant="outline-primary"
                      className="w-100"
                      size="lg"
                      >
                      View
                    </Button>
                </div>
              </div>
            </div>
            
            <div className="col">
              <div className="card mb-4 rounded-3 shadow-sm" style={{width: "100%"}}>
                <div className="card-header py-3">
                  <h4 className="my-0 fw-normal">Reports for 2020-2021</h4>
                </div>
                <div className="card-body">
                  <p>
                  All submitted program and general education learning outcomes assessment reports for the academic year
                  </p>
                    <Button
                      href="v1/2020-2021"
                      variant="outline-primary"
                      className="w-100"
                      size="lg"
                      >
                      View
                    </Button>
                </div>
              </div>
            </div>

          </div>
          
          
        </main>

        <Footer />
      </div>
    </PageLayout>
  )
}

export default IndexPage
